/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Badge,
  ThemeProvider,
  Theme,
  StyledEngineProvider,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Dispatch, FC, SetStateAction, useCallback, useEffect, useMemo, useState } from "react";
import { ListagemItem, Projeto, SugestaoInstalacao } from "src/components/projetos/types";
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import { setDimensionadoTabDisabledStatus, setDimensionadoTabDoneStatus } from "src/store/vendas/projetos/actions";
import theme from "src/theme/light";
import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider";
import { CalcularAcessoriosRequest, ProjetosProvider } from "src/providers/ProjetosProvider";
import { ModalInstalacao } from "src/components/projetos/ModalInstalacao";
import { CategoriaComponente, ID_CABO, TGrupoCategoria } from "src/components/componentes/types";
import { ORDEM_GRUPO_CATEGORIAS, POSICAO_MODULO, VALOR_MULTIPLO_CABO, PROJETOS_ITENS_SEM_SUGESTAO_INSTALACAO } from "src/components/projetos/constants";
import { LayoutProjetoDimensionado } from "../../_layouts";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { quantidadesMinimas$, TabName } from "../..";
import { showPopupParceiroPowerAlert } from "src/components/projetos/utils/showPopupParceiroPowerAlert";
import { categorias_componentes$, fraseParceiro$, getFraseParceiro } from "src/store/global.store";
import { useObservable } from "src/framework/store/storeUtil";
import { MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants";
import { FindInPageOutlined } from "@mui/icons-material";
import { modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store";
import { ModalCorrenteReversa } from "src/components/projetos/ModalCorrenteReversa";
import adminStore from "src/store/AdminStore";
import defaultListStore from "src/framework/store/DefaultListStore";
import { ConteudoModalInstalacao } from "src/components/projetos/ModalInstalacao/ConteudoModalInstalacao";
import ReactDOMServer from "react-dom/server";
import "./style.css";
import { ModalModulosStrings } from "src/components/projetos/ModalModulosString";
import ComponentesListMobile from "./ComponentesListMobile";
import { ModalRestaurarSolucao } from "src/components/projetos/containers/ModalRestaurarSolucao";
import { elSemEstrutura } from "src/components/projetos/dimensionados_offgrid/containers/modalEditarEstruturas";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { ConfiguracaoStore } from "src/framework/store/ConfiguracaoStore";
import api from "src/framework/providers/api";


declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

interface SolucaoProps {
  formState: Projeto;
  onChangeFormState: Dispatch<SetStateAction<Projeto>>
  onClickNext: () => void;
  onClickBack: (tabBack?: TabName) => void;
  onEditarEstruturas: () => void;
}

const useStyles = makeStyles({
  warningText: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  moduleTitle: {
    fontWeight: 600,
  },
  restoreButton: {
    backgroundColor: theme.palette.warning.dark,
    color: theme.palette.getContrastText(theme.palette.warning.dark),
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    }
  },
  restoreButtonConfirm: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.getContrastText(theme.palette.error.main),
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    }
  }
})

const componenteProvider = new ComponenteProvider()
const projetosProvider = new ProjetosProvider()
const store = new ConfiguracaoStore(api, PROJETOS_ITENS_SEM_SUGESTAO_INSTALACAO)

export interface IComponenteQuantidade {
  componente_id: number;
  quantidade: number;
}

const Solucao: FC<SolucaoProps> = ({ formState, onChangeFormState, onClickNext, onClickBack, onEditarEstruturas }) => {
  const classes = useStyles();
  const permissoes = PermissionUtil.getPermissions();
  
  const [sugestaoModalIsOpened, setSugestaoModalIsOpened] = useState(false)
  const [correnteReversaModalIsOpened, setCorrenteReversaModalIsOpened] = useState(false)
  const [modulosStringModalIsOpened, setModulosStringModalIsOpened] = useState(false)
  const [solucaoData, setSolucaoData] = useState<ListagemItem[]>([]);

  const fraseParceiroPowerAlert = useObservable(fraseParceiro$);
  const categoriasComponentes = useObservable(categorias_componentes$);

  const [fraseParceiroExibidoList] = useState<number[]>([]);

  const [componentesState, setComponentesState] = useState<any>([]);
  const [modulosInversoresState, setModulosInversoresState] = useState<any>([]);
  const [restaurouSolucao, setRestaurouSolucao] = useState<boolean>(false);
  const [modalRestaurarSolucaoIsOpened, setModalRestaurarSolucaoIsOpened] = useState<boolean>(false);
  const [produtosIgnorados, setProdutosIgnorados] = useState<number[]>([]);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const setFormState = useCallback((newState: Partial<Projeto>)=>{
    onChangeFormState(old => ({...old, ...newState}))
  },[onChangeFormState])

  const alterouPotencia = useMemo(() => {
    const sugestaoModulo = formState?.sugestoes?.modulo;

    const moduloSelecionado = formState.modulosList?.find(item => item.selecionado) || null;
    const potenciaModulosEmWatts = moduloSelecionado ? (moduloSelecionado.quantidade * moduloSelecionado.potencia) : 0;
    const potenciaModulos = Number((potenciaModulosEmWatts || 0) / 1000);
    const potenciaDesejada = Number(formState.potencia_desejada || 0);

    const alterouModulo = (sugestaoModulo?.id || 0) !== moduloSelecionado?.componente_id;
    const alterouQuantidade = (sugestaoModulo?.quantidade || 0) !== moduloSelecionado?.quantidade;

    return (alterouModulo || alterouQuantidade) && potenciaModulos !== potenciaDesejada;
  },[formState.potencia_desejada, formState.modulosList, formState?.sugestoes]);

  const isAdmin = useMemo(() => {
    return PermissionUtil.can('*', permissoes)
  }, [permissoes])

  const temPermissaoCodigoComponente = useMemo(()=>{
    return PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE, permissoes)
},[permissoes])

  useEffect(() => {
    const carregarParametros = async () => {
      const parametros = await store.list();
      const valor = parametros?.[0]?.valor ?? "";
      setProdutosIgnorados(valor?.split(",")?.map((item: string) => Number(item.trim()))?.filter(Number.isFinite));
    }
    carregarParametros();
  }, []);

  const ignorarSugestaoInstalacao = useMemo(() => {
    if (formState?.corrente_reversa) return false;
    const componentes = formState?.inversoresList?.filter(i => i?.quantidade > 0) || [];
    return componentes?.some((i) => produtosIgnorados?.includes(i?.componente_id)) ?? false;
  }, [formState?.componentes, formState?.inversoresList, formState?.corrente_reversa, produtosIgnorados]);

  const divergenciaStrings = useMemo(() => {
    return (formState?.divergencia_strings && !ignorarSugestaoInstalacao)
  }, [formState?.divergencia_strings, ignorarSugestaoInstalacao])

  const withAlerta = useMemo(() => {
    return formState?.corrente_reversa || divergenciaStrings
  }, [formState?.corrente_reversa, divergenciaStrings])

 const mensagemAlerta = useMemo(() => {
    if (ignorarSugestaoInstalacao) return "Indisponível para o inversor selecionado";
    if (formState?.corrente_reversa) return "Risco de corrente reversa identificado!";
    if (divergenciaStrings) return "Quantidade de módulos diferentes nas strings de um mesmo MPPT!";
    return "";
  }, [formState?.corrente_reversa, divergenciaStrings, ignorarSugestaoInstalacao])

  const mostrarColunasAdicionais = useMemo(()=>{
    return !formState.clonar_projeto && formState.isEdit && isAdmin
  },[formState.isEdit, formState?.clonar_projeto, isAdmin])

  const projetoFiname = useCallback( () => (formState?.modulosList?.some(item => item?.finame && item.selecionado) && !["personalizado"]?.includes(formState?.tipo || "")) || false
  , [formState?.modulosList])

  useEffect(()=>{
    componenteProvider.buscarCategoriasPorGrupo("acessorios").then(res => {
      const categoriasIds = res.map(item => item.id)
      if (!!categoriasIds.length && formState.tipo_inversor?.value) {
        componenteProvider.buscarComponentesPorCategoria({
          categoria_componentes_id: categoriasIds,
          categoria_inversor_id: formState.tipo_inversor.value,
          regiao_id: formState.regioes.map(item => item.id),
          inversores_id: formState?.inversoresList?.filter(item => item?.quantidade > 0)?.map(item => item?.componente_id),
          segmento: formState.segmento?.includes("on") ? "on" : "off",
        }).then(result => {
          const selectedModulo = formState.modulosList?.find(item => item.selecionado)
          if (!selectedModulo) {
            return;
          }

          if (!formState.inversoresList?.length) {
            return
          }

          if (!formState.inversoresList.filter(item => item.quantidade > 0).length) {
            return;
          }

          const acessoriosRequestPayload: CalcularAcessoriosRequest = {
            regiao_id: formState.regioes.map(item => item.id),
            segmento: formState.segmento?.includes("on") ? "on" : "off",
            inversores: formState.inversoresList.filter(item => item.quantidade > 0).map(item => ({
              categoria_componentes_id: item.categoria_componentes_id,
              id: item.componente_id,
              quantidade: item.quantidade,
            }))
          }
          
          const acessoriosSugeridos: Array<{id: number; quantidade: number; categoria_componentes_id: number;}> = [];
          const inversoresSugeridosComQuantidade = formState.sugestoes?.inversores?.filter(item => item.quantidade > 0) || [];

          if (inversoresSugeridosComQuantidade.length) {
            // Para saber os acessórios sugeridos com base nos inversores sugeridos, sem considerar alterações feitas pelo usuário, manualmente.
            projetosProvider.calcularAcessorios(selectedModulo.componente_id, {
              ...acessoriosRequestPayload,
              inversores: inversoresSugeridosComQuantidade.map(item => ({
                categoria_componentes_id: item.categoria_componentes_id,
                id: item.id,
                quantidade: item.quantidade,
              }))
            }).then(result => {
              if (result.data.length) {
                const acessoriosSugeridosResult = Array.isArray(result.data) ? result.data : [];

                acessoriosSugeridos.push(...acessoriosSugeridosResult.filter(item => item.quantidade > 0).map(item => ({
                  id: Number(item.id || 0),
                  quantidade: item.quantidade,
                  categoria_componentes_id: item.categoria_componentes_id || 0,
                })))
              }
            })
        }
          
          projetosProvider.calcularAcessorios(selectedModulo.componente_id, acessoriosRequestPayload).then(async sugestao => {
            const acessorios = result.map(res => {
              const qtd = sugestao.data.find(item => item.id === res.id)?.quantidade || 0
              const atributos = sugestao.data.find(item => item.id === res.id)?.atributos || [];
              return {
                ...res,
                quantidade: qtd,
                atributos,
              }
            })

            const _acessorios = acessorios.map(acc => {
              const acessorio = formState.acessorios?.find(item => item.componente_id === acc.id)
              const acessorioSugerido = formState.sugestoes.acessorios.find(item => item.id === acc.id)
              const isChanged = acessorio?.quantidade !== acessorioSugerido?.quantidade

              return {
                altura: Number(acc.altura || 0),
                categoria_componentes_id: Number(acc.categoria_componentes_id || 0),
                componente_id: Number(acc.id || 0),
                descricao: String(acc.descricao || ''),
                largura: Number(acc.largura || 0),
                nome: acc.nome_componente,
                peso: Number(acc.peso || 0),
                potencia: 0,
                quantidade: isChanged ? (acessorio?.quantidade || acc.quantidade) : acc.quantidade,
                valor: 0,
                valor_unitario: acessorio?.valor_unitario || 0,
                exibir_popup_parceiro: acc.exibir_popup_parceiro,
                atributos: acc.atributos,
                regra_indicacao: acc?.regra_indicacao || []
              }
            })

            const _sugestoes =  {
              ...formState.sugestoes,
              acessorios: acessorios.map(item => ({
                id: item.id ? Number(item.id) : 0,
                quantidade: item.quantidade,
                categoria_componentes_id: item.categoria_componentes_id || 0,
              }))
            }

            const _quantidadesMinimas: IComponenteQuantidade[] = [];

            _acessorios.forEach(ac => {
              if (!_quantidadesMinimas.some(q => q.componente_id === ac.componente_id)) {
                _quantidadesMinimas.push({
                  componente_id: ac.componente_id,
                  quantidade: ac.quantidade
                })
              }
            })

            _sugestoes.acessorios.forEach(ac => {
              if (!_quantidadesMinimas.some(q => q.componente_id === ac.id)) {
                _quantidadesMinimas.push({
                  componente_id: ac.id,
                  quantidade: ac.quantidade
                })
              }
            })

            // setQuantidadesMinimas(_quantidadesMinimas)

            const frase = await getFraseParceiro();
            let exibiuMensagem = false;

            _acessorios?.forEach(ac => {
              if(ac.exibir_popup_parceiro) {
                const qtdMinima = _quantidadesMinimas.find(q => q.componente_id === ac.componente_id)?.quantidade || 0;
                if((ac.quantidade > 0 || qtdMinima > 0) && exibiuMensagem  === false && !formState.isEdit) {
                  showPopupParceiroPowerAlert(frase);
                  exibiuMensagem = true;
                }
              }
            });

            if(exibiuMensagem === false && !formState.isEdit) {
              formState.estrutura_calculadas?.forEach(es => {
                if(es.exibir_popup_parceiro) {
                  const qtdMinima = _quantidadesMinimas.find(q => q.componente_id === es.componente_id)?.quantidade || 0;
                  if((es.quantidade > 0 || qtdMinima > 0) && exibiuMensagem  === false) {
                    showPopupParceiroPowerAlert(frase);
                    exibiuMensagem = true;
                  }
                }
              });
            }

            setFormState({
              acessoriosSugeridos: acessoriosSugeridos,
              acessorios: _acessorios,
              sugestoes: _sugestoes
            })
            setTimeout(() => {
              const qtdMinimas = quantidadesMinimas$.getValue();
              qtdMinimas.push(..._quantidadesMinimas) 
              quantidadesMinimas$.next(qtdMinimas)
            }, 300)
          })
        })
      }
    })
  },[formState.inversoresList, formState.modulosList, formState.regioes, formState.tipo_inversor, setFormState])

  useEffect(() => {
    const selectedModulo = formState.modulosList?.find(item => item.selecionado)
    if (!selectedModulo || !formState.inversoresList?.length || !formState.inversoresList?.filter(item => item.quantidade > 0)?.length) {
      return;
    }

    projetosProvider.calcularCorrenteReversa(selectedModulo.componente_id, {
      inversores: formState.inversoresList.filter(item => item.quantidade > 0).map(item => item.componente_id)
    }).then(async resp => {
      setFormState({ corrente_reversa: resp.data?.corrente_reversa });

      if (!resp.data?.corrente_reversa) {
        const listaInversores = formState?.inversoresList || [];
        projetosProvider.calcularModulosStrings(selectedModulo.componente_id, {
          tipo: 'dimensionado',
          segmento: 'distribuicao_ongrid',
          quantidade_modulos: selectedModulo.quantidade,
          inversores: listaInversores?.filter(item => item.quantidade > 0)?.map(item => ({ id: item.componente_id, quantidade: item.quantidade }))
        }).then(async resp => {
          setFormState({ divergencia_strings: resp.data?.divergencia_strings });
        })
      }
    })
  },[formState.inversoresList, formState.modulosList, formState.regioes, formState.tipo_inversor, setFormState])

  const moduloSelecionado = useMemo(()=>{
    return formState.modulosList?.find(item => item.selecionado)
  },[formState.modulosList])

  const inversoresComQuantidade = useMemo(()=>{
    return formState.inversoresList?.filter(item => Number(item.quantidade || 0) > 0) || []
  },[formState.inversoresList])

  const acessoriosRecomendados = useMemo(()=>{
    return formState.acessorios || []
  }, [formState.acessorios])
  
  useEffect(()=>{
    const items: ListagemItem[] = []
    const categorias = categoriasComponentes?.data || [];

    if (moduloSelecionado) {
      items.push(moduloSelecionado)
    }

    items.push(...inversoresComQuantidade)
    
    const estrutura = formState.estrutura_calculadas || []
    items.push(...estrutura)

    items.push(...acessoriosRecomendados)

    const itemsOrder = items?.map(item => {
      const categoria = categorias?.find((i: CategoriaComponente) => i.id === item?.categoria_componentes_id);
      return {
        ...item,
        nome_categoria: categoria?.nome || "",
        grupo_categoria: categoria?.grupo || "",
        ordem_listagem: categoria?.ordem_listagem || item?.categoria_componentes_id,
      }
    })?.sort((a, b) => {
      const pesoGrupoA = ORDEM_GRUPO_CATEGORIAS[a.grupo_categoria as TGrupoCategoria] || a?.categoria_componentes_id;
      const pesoGrupoB = ORDEM_GRUPO_CATEGORIAS[b.grupo_categoria as TGrupoCategoria] || b?.categoria_componentes_id;

      if (pesoGrupoA !== pesoGrupoB) {
        return pesoGrupoA - pesoGrupoB;
      }

      return a.ordem_listagem - b.ordem_listagem;
    });

    setSolucaoData(itemsOrder)

    // acessoriosRecomendados.forEach((ar) => {
    //   const _quantidadesMinimas = [...quantidadesMinimas]
    //   if (!_quantidadesMinimas.some(qm => qm.componente_id === ar.componente_id)) {
    //     _quantidadesMinimas.push({
    //       componente_id: ar.componente_id,
    //       quantidade: ar.quantidade
    //     })
    //   }
    // })

  },[acessoriosRecomendados, formState.estrutura_calculadas, moduloSelecionado, inversoresComQuantidade, formState.estruturasSelecionadas, categoriasComponentes])
  
  useEffect(() => {
    const ids = inversoresComQuantidade.map(item => ({ id: item.componente_id, quantidade: item.quantidade }))
    if (!!ids.length) {
      const componentesIds: number[] = [];
      ids.forEach(componentId => {
        componentesIds.push(componentId.id);
      });
      const joinComponentesIds = componentesIds.join(',');
      adminStore.getComponentesByIds(joinComponentesIds).then((resp) => {
        setComponentesState(resp);
      })
    }
  }, [inversoresComQuantidade]);

  useEffect(() => {
    const ids = inversoresComQuantidade.map(item => ({ id: item.componente_id, quantidade: item.quantidade }))
    const moduloId = moduloSelecionado?.componente_id;
    const quantidadeModulos = moduloSelecionado?.quantidade;
    if (!moduloId || !quantidadeModulos) return;

    if (ids && (componentesState?.length === 0 || restaurouSolucao)) {
      const modulos_inversores =  adminStore.getModulosInversoresCalculados(ids, moduloId, quantidadeModulos);
      modulos_inversores.then(resp => {
        if (resp && resp.length > 0) {
          setModulosInversoresState(resp);
          defaultListStore.getUpload();
        }
      })
    }
  }, [inversoresComQuantidade, moduloSelecionado, componentesState, restaurouSolucao]);
  
  const checkError = useCallback((categoriaId: number, qtd: number): boolean => {
    if (categoriaId !== ID_CABO) {
      return false;
    }
    if (qtd === 0) {
      return false;
    }
    if (qtd % 25 === 0) {
      return false;
    }
    return true
  },[])

  const nextButtonIsDisabled = useMemo(()=>{
    const cabos = solucaoData.filter(item => item.categoria_componentes_id === ID_CABO)
    if (cabos.some(cabo => checkError(cabo.categoria_componentes_id, Number(cabo.quantidade)))) {
      return true
    }
    if (formState?.corrente_reversa || divergenciaStrings) {
      return true
    }
    return false;
  },[checkError, solucaoData, formState?.corrente_reversa, divergenciaStrings])

  useEffect(()=>{
    setDimensionadoTabDisabledStatus('valor_total', nextButtonIsDisabled)
    setDimensionadoTabDoneStatus('solucao', !nextButtonIsDisabled)
  },[nextButtonIsDisabled])

  const handleChangeQuantity = useCallback((id: number, value: string)=> {
    const isStructure = formState.estrutura_calculadas?.find(item => item.componente_id === id)
    const isAccessory = formState.acessorios?.find(item => item.componente_id === id)
    const quantidade = Number(value || 0);
  

    if(isStructure?.exibir_popup_parceiro || isAccessory?.exibir_popup_parceiro) {
      const idx = fraseParceiroExibidoList.findIndex(c => c === id);
      if(idx < 0 && quantidade > 0) {
        if(fraseParceiroPowerAlert?.data) {
          showPopupParceiroPowerAlert(fraseParceiroPowerAlert.data);
          fraseParceiroExibidoList.push(id);
        }
      } else {
        if(quantidade === 0) {
          fraseParceiroExibidoList.splice(idx, 1);
        }
      }
    }

    if (isStructure) {
      const newStructureList = formState.estrutura_calculadas?.map((item) => {
        if (item.componente_id === id) {
          item.quantidade = quantidade
        }
        return item
      })
      setFormState({ estrutura_calculadas: newStructureList })
      return
    }

    if (isAccessory) {
      const newAccesoryList = formState.acessorios?.map((item) => {
        if (item.componente_id === id) {
          item.quantidade = quantidade
        }
        return item
      })
      setFormState({ acessorios: newAccesoryList })
    }
  },[formState.estrutura_calculadas, formState.acessorios, setFormState, fraseParceiroPowerAlert])
  
  const handleRestore = useCallback(() => {
    confirmationDialog.setup({
      title:'Atenção',
      content: (
        <>
          <Box mb={2}>
            <Typography>
              <strong>Restauração da solução</strong>
            </Typography>
          </Box>

          <Typography>Você tem certeza que deseja restaurar a solução?</Typography>
          <Typography>Há produtos selecionados neste projeto, você irá perder a configuração personalizada, pois será restaurada a solução sugerida.</Typography>
        </>
      ),
      onConfirmation: () => {
        const sugestaoModulo = formState.sugestoes.modulo
        const newModulos = formState.modulosList?.map(item => {
          if (item.componente_id === sugestaoModulo.id) return {...item, quantidade: sugestaoModulo.quantidade}
          return item
        })
        const sugestaoInversores = formState.sugestoes.inversores || []
        const newInversoresList = formState.inversoresList?.map((item) => {
          const sugestao = sugestaoInversores.find(sugestao => sugestao.id === item.componente_id)
          return {
            ...item,
            quantidade: sugestao?.quantidade || 0
          }
        })

        const sugestoEstruturas = formState.sugestoes.estrutura || []
        const newEstruturas = formState.estrutura_calculadas?.map((item) => {
          const sugestao = sugestoEstruturas.find(sugestao => sugestao.id === item.componente_id)
          return {
            ...item,
            quantidade: sugestao?.quantidade || 0
          }
        })

        const sugestaoAcessorios = formState.sugestoes.acessorios || []
        const newAcessorios = formState.acessorios?.map((item) => {
          const sugestao = sugestaoAcessorios.find(sugestao => sugestao.id === item.componente_id)
          return {
            ...item,
            quantidade: sugestao?.quantidade || 0
          }
        })

        if (alterouPotencia && formState?.estrutura_calculadas?.length) {
          setModalRestaurarSolucaoIsOpened(true);
        }

        setFormState({
          modulosList: newModulos,
          inversoresList: newInversoresList,
          estrutura_calculadas: newEstruturas,
          acessorios: newAcessorios,
          retornou_tela: false,
          sugestao_instalacao: undefined
        })

        setRestaurouSolucao(true);
      },
      onClose: () => confirmationDialog.close(),
      onNegation: () => confirmationDialog.close(),
      yesText: 'Restaurar',
      noText: 'Cancelar',
      submitButtonClassName: classes.restoreButtonConfirm
    })
    confirmationDialog.open()
  }, [classes.restoreButtonConfirm, formState.acessorios, formState.estrutura_calculadas, formState.inversoresList, formState.modulosList, formState.sugestoes.acessorios, formState.sugestoes.estrutura, formState.sugestoes.inversores, formState.sugestoes.modulo, alterouPotencia, setFormState])

  const removerEstruturas = useCallback(() => {
    const limpaEstrutura: ListagemItem[] = [];
    const moduloSelecionado =  formState.modulosList?.find(item => item.selecionado);
    const posicaoRetrato = POSICAO_MODULO.find(i => i.value === 'retrato') || null;
    const newSugestoes = {...formState.sugestoes, estrutura: [] };
    const newFileiras = [{
      fileiras: 1,
      posicao_modulo: posicaoRetrato,
      tipo_estrutura: elSemEstrutura || null,
      quantidade_modulos: moduloSelecionado?.quantidade || 0
    }];

    setFormState({
      fileiras: newFileiras,
      sugestoes: newSugestoes,
      estrutura_calculadas: limpaEstrutura,
      retornou_tela: false,
      sugestao_instalacao: undefined
    });
  }, [formState.estrutura_calculadas, formState.sugestoes, formState.modulosList, setFormState])

  useEffect(() => {

    const parseDadosIniciais = async () => {
      const _quantidadesMinimas: IComponenteQuantidade[] = [];
      const _mSelecionado =  formState.modulosList?.find(item => item.selecionado);
      const _inversores = formState.inversoresList?.filter(item => Number(item.quantidade || 0) > 0) || []
      const _acessorios = formState.acessorios || []

      if (_mSelecionado) {
        _quantidadesMinimas.push({
          componente_id: _mSelecionado.componente_id,
          quantidade: _mSelecionado.quantidade
        })
      }
      
      formState.estrutura_calculadas?.forEach(es => {
        _quantidadesMinimas.push({
          componente_id: es.componente_id,
          quantidade: es.quantidade
        })
      })

      _inversores?.forEach(_in => {
        _quantidadesMinimas.push({
          componente_id: _in.componente_id,
          quantidade: _in.quantidade
        })
      })
      
      _acessorios?.forEach(_ac => {
        _quantidadesMinimas.push({
          componente_id: _ac.componente_id,
          quantidade: _ac.quantidade
        })
      })

      let exibiuMensagem = false;

      formState.acessorios?.forEach(ac => {
        if(ac.exibir_popup_parceiro) {
          /*
          if((ac.quantidade > 0 || qtdMinima > 0) && exibiuMensagem  === false) {
            showPopupParceiroPowerAlert(frase);
            exibiuMensagem = true;
          }
          */
        }
      });

      if(exibiuMensagem === false) {
        formState.estrutura_calculadas?.forEach(es => {
          if(es.exibir_popup_parceiro) {
            /*
            if((es.quantidade > 0 || qtdMinima > 0) && exibiuMensagem  === false) {
              showPopupParceiroPowerAlert(frase);
              exibiuMensagem = true;
            }
            */
          }
        });
      }

      quantidadesMinimas$.next(_quantidadesMinimas)

    }

    parseDadosIniciais();
  }, []);

 const renderComponentes = useCallback(() => {
    if (isMobile) {
      return <ComponentesListMobile 
        solucaoData={solucaoData}
        projetoFiname={projetoFiname()}
        temPermissaoCodigoComponente={temPermissaoCodigoComponente}
        mostrarColunasAdicionais={mostrarColunasAdicionais}
        handleChangeQuantity={handleChangeQuantity}
        checkError={checkError}
      />
    }

    return (
      <TableContainer component={Paper}>
        <Table aria-label="listagem de modulos disponíveis">
          <TableHead>
            <TableRow>
              {temPermissaoCodigoComponente && <TableCell align='left'><strong>Código</strong></TableCell>}
              <TableCell align='left'><strong>Produtos</strong></TableCell>
              <TableCell align='center'><strong>Quantidade</strong></TableCell>
              {mostrarColunasAdicionais && <TableCell align='center'><strong>Valor Unit.</strong></TableCell>}
              <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {solucaoData?.map((row) => {
              let quantidadeMinima = 0
              const temRegraIndicacao = !!row?.regra_indicacao?.length;

              if (projetoFiname()) {
                const tipoCaboAttr = (row.atributos || []).find(item => item.atributo === 'TIPO_CABO')
                const tipoCabo = tipoCaboAttr ? Number(tipoCaboAttr?.valor) : null;
                const ignorarRegraQtdMinima = tipoCabo === 3;

                if (!ignorarRegraQtdMinima) {
                  quantidadeMinima = quantidadesMinimas$.getValue().find(qt => qt.componente_id === row.componente_id)?.quantidade || 0
                  if (row.categoria_componentes_id === ID_CABO) {
                    quantidadeMinima = VALOR_MULTIPLO_CABO
                    if (row.quantidade === 0) {
                      row.quantidade = VALOR_MULTIPLO_CABO
                    }
                  }
                }
              }

              return (
                <TableRow key={row.componente_id}>
                  {temPermissaoCodigoComponente && (
                    <TableCell style={{ maxWidth: '400px' }} align='left' component="th">
                      <span>{row.componente_id || ''}</span>
                    </TableCell>
                  )}

                  <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                    <Box textAlign={'left'}>
                      <Typography className={classes.moduleTitle} variant='body1' color='textPrimary'>
                        {row.nome}
                      </Typography>
                      <Typography variant='body2' color='textSecondary'>
                        <span className={classes.warningText}>Informações</span>: {row.descricao}
                      </Typography>
                    </Box>
                  </TableCell>

                  <TableCell align='center' component="th">
                    <Tooltip title={projetoFiname() ? "A quantidade do produto não pode ser inferior a quantidade sugerida!" : ""}>
                      <Box width="180px" margin={"0 auto"}>
                        <InputQuantidade
                          minValue={quantidadeMinima}
                          hasError={checkError(row.categoria_componentes_id, row.quantidade)}
                          multiple={row.categoria_componentes_id === ID_CABO ? VALOR_MULTIPLO_CABO : 1}
                          disabledInput={false}
                          highlightField={false}
                          disabled={[1, 2].includes(row.categoria_componentes_id) || temRegraIndicacao}
                          value={row.quantidade}
                          onChange={(v: any) => handleChangeQuantity(row.componente_id, v)}
                          onBlur={(v: any) => {
                            if (projetoFiname() && (!v || Number(v) < quantidadeMinima)) {
                              handleChangeQuantity(row.componente_id, quantidadeMinima.toString())
                            }
                          }}
                        />
                        {row.categoria_componentes_id === ID_CABO && checkError(row.categoria_componentes_id, row.quantidade) && (
                          <span style={{ color: "#b91322" }}>{MENSAGEM_QUANTIDADE_CABOS_INVALIDA}</span>
                        )}
                      </Box>
                    </Tooltip>
                  </TableCell>

                  {mostrarColunasAdicionais && (
                    <TableCell style={{ maxWidth: '400px' }} align='center' component="th">
                      <span>{Formater.toString(row.valor_unitario, TypeRecords.CURRENCY)}</span>
                    </TableCell>
                  )}

                  <TableCell align='center' component="th">
                    <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                      <IconButton
                        onClick={() => row.componente_id && modalComponentesDetalhesData$.next(row.componente_id)}
                        size="large">
                        <FindInPageOutlined htmlColor="black" />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [classes, handleChangeQuantity, solucaoData, projetoFiname, checkError, mostrarColunasAdicionais, temPermissaoCodigoComponente, isMobile])

  return (
    <>
      <LayoutProjetoDimensionado
        formState={formState}
        title="Solução"
        nextButtonIsDisabled={nextButtonIsDisabled}
        onClickBack={() => {
          setFormState({ retornou_tela: true });
          onClickBack();
        }}
        onClickNext={() => {
          if (!ignorarSugestaoInstalacao) {
            const conteudoModalInstalacao = ReactDOMServer.renderToString(
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                  <ConteudoModalInstalacao 
                    componentesState={componentesState} 
                    modulosInversoresState={modulosInversoresState}
                  />
                </ThemeProvider>
              </StyledEngineProvider>
            );
            setFormState({ sugestao_instalacao: {...formState.sugestao_instalacao, texto: conteudoModalInstalacao } });
          }
          onClickNext();
        }}
      >
        <Box p={2}>
          { renderComponentes() }

          <Box mt={4} className="row" display="flex" justifyContent={"flex-end"}>
            <Button 
              style={{
                marginRight: isMobile ? 0 : 16,
                marginBottom: isMobile ? 25 : 0,
                ...(withAlerta && { color: "#b91322", borderColor: "#b91322" }),
                ...(ignorarSugestaoInstalacao && { 
                  color: "rgba(0, 0, 0, 0.26)",
                  borderColor: "rgba(0, 0, 0, 0.12)",
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                  opacity: 0.7,
                })
              }}
              color="secondary" 
              variant="outlined"
              fullWidth={isMobile}
              onClick={() => {
                if (formState?.corrente_reversa) {
                  setCorrenteReversaModalIsOpened(true);
                } else if (divergenciaStrings) {
                  setModulosStringModalIsOpened(true);
                } else if (!ignorarSugestaoInstalacao) {
                  setSugestaoModalIsOpened(true);
                }
              }}
            >
              <Tooltip title={mensagemAlerta}>
                <Badge badgeContent={withAlerta ? "!" : null} color="error" className="Badge-Corrente-Reversa">
                  Sugestões Instalação
                </Badge>
              </Tooltip>
            </Button>
            <Button variant="contained" onClick={handleRestore} className={classes.restoreButton} fullWidth={isMobile}>Restaurar Solução</Button>
          </Box>
        </Box>
      </LayoutProjetoDimensionado>
      {sugestaoModalIsOpened && moduloSelecionado && !!inversoresComQuantidade.length && (
        <ModalInstalacao 
          isOpened={sugestaoModalIsOpened} 
          close={() => setSugestaoModalIsOpened(false)}
          componentesState={componentesState} 
          modulosInversoresState={modulosInversoresState}
        />
      )}
      {correnteReversaModalIsOpened && moduloSelecionado && !!inversoresComQuantidade.length && (
        <ModalCorrenteReversa 
          isOpened={correnteReversaModalIsOpened} 
          close={() => setCorrenteReversaModalIsOpened(false)} 
          onChange={(sugestao_instalacao: SugestaoInstalacao) => {
            setFormState({ corrente_reversa: false, divergencia_strings: false, sugestao_instalacao });
            setCorrenteReversaModalIsOpened(false);
          }} 
        />
      )}
      {modulosStringModalIsOpened && moduloSelecionado && !!inversoresComQuantidade.length && (
        <ModalModulosStrings 
          isOpened={modulosStringModalIsOpened} 
          componentesState={componentesState} 
          modulosInversoresState={modulosInversoresState}
          close={() => setModulosStringModalIsOpened(false)}           
          onBack={() => {
            setModulosStringModalIsOpened(false);
            onClickBack('modulos');
          }} 
          onChange={(sugestao_instalacao: SugestaoInstalacao) => {
            setFormState({ corrente_reversa: false, divergencia_strings: false, sugestao_instalacao });
            setModulosStringModalIsOpened(false);
          }} 
        />
      )}
      {modalRestaurarSolucaoIsOpened && (
        <ModalRestaurarSolucao 
          isOpened={modalRestaurarSolucaoIsOpened} 
          closeModal={() => setModalRestaurarSolucaoIsOpened(false)}
          finame={projetoFiname()}
          onEditarEstruturas={()=>{
            onEditarEstruturas();
            setModalRestaurarSolucaoIsOpened(false);
          }}
          onRemoverEstruturas={() => {
            removerEstruturas();
            setModalRestaurarSolucaoIsOpened(false);
          }}
        />
      )}
    </>
  );
}
export { Solucao }